export const FETCH_ONCALL_ORDER_DETAIL_PENDING = 'FETCH_ONCALL_ORDER_DETAIL_PENDING';
export const FETCH_ONCALL_ORDER_DETAIL_REJECTED = 'FETCH_ONCALL_ORDER_DETAIL_REJECTED';
export const FETCH_ONCALL_ORDER_DETAIL_FULFILLED = 'FETCH_ONCALL_ORDER_DETAIL_FULFILLED';
export const CLEAR_ONCALL_ORDER_DETAIL = 'CLEAR_ONCALL_ORDER_DETAIL';
export const SET_ID_ONCALL_ORDER_DETAIL = 'SET_ID_ONCALL_ORDER_DETAIL';



// WEBPACK FOOTER //
// ./src/constants/oncallOrderDetail.js